module.exports = __webpack_public_path__ + "f71f913928feca6f3a961490c39063d2.svg";